export default "__VITE_ASSET__CuAwiabY__"